module.exports = __webpack_public_path__ + "static/media/pro-graphic.57535b82.png";